import { createSelector } from 'reselect';

const globalSearchState = state => state.globalSearchReducer;

export const getSelectedCustomerListPagination = createSelector(
    [globalSearchState],
    search => search?.customer_data || []
)

export const getSelectedCustomerList = createSelector(
    [globalSearchState],
    search => search?.customer_data.content || []
)

export const getCustomerListSelector = createSelector(
  [globalSearchState],
  search => search?.customer_search_list?.content || []
);

export const customerSearchTaskList = createSelector(
  [globalSearchState],
  search => search?.customer_search_task_list?.content || []
);

export const getCustomerListPaginationSelector = createSelector(
  [globalSearchState],
  search => search?.customer_search_list || []
);

export const getCustomerQuoteDataSelector = createSelector(
  [globalSearchState],
  search => search?.customer_quote_data?.content || []
);

export const getCustomerQuotePaginationSelector = createSelector(
  [globalSearchState],
  search => search?.customer_quote_data || []
);
